module.exports = __webpack_public_path__ + "img/39-e5e4c4.png";